import React from "react";
import Modal from "../styled/Modal/Modal";
import { ModalBody } from "react-bootstrap";
import { Stage } from "./style";
import "./style.css";
import PropTypes from "prop-types";

const LoadingModal = ({ show, onHide, title, body, block }) => {
  return (
    <Modal show={show} onHide={block ? () => { } : onHide} centered>
      <ModalBody>
        <h4 style={{ fontSize: "2.2rem" }}>{title}</h4>
        <p className="my-5">{body}</p>
        <div class="snippet" data-title=".dot-floating">
          <Stage>
            <div className="dot-floating"></div>
          </Stage>
        </div>
      </ModalBody>
    </Modal>
  );
};

LoadingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.string,
  block: PropTypes.bool,
  Component: PropTypes.element,
};

export default LoadingModal;
